import { createFileRoute } from "@tanstack/react-router";
import { categoryRouteOptions } from "@/lib/categoryLandingRoute";

export const Route = createFileRoute("/used-rvs")(categoryRouteOptions("used-rvs"));
